import React from "react"
import PropTypes from "prop-types"
import classNames from "classnames"

import {
  body,
  bold as boldStyle,
  brand as brandStyle,
  centered as centeredStyle,
  heading,
  italic as italicStyle,
  large as largeStyle,
  light as lightStyle,
  marginBottom as marginBottomStyle,
  noMarginBottom as noMarginBottomStyle,
  sans as sansStyle,
  semibold as semiboldStyle,
  serif as serifStyle,
  smSmall as smSmallStyle,
  small as smallStyle,
  title,
  typography,
  uppercase as uppercaseStyle,
  useParentFontWeight as useParentFontWeightStyle,
  useParentSize as useParentSizeStyle,
  white as whiteStyle,
} from "./styles.module.scss"

const componentPropTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  serif: PropTypes.bool,
  sans: PropTypes.bool,
  bold: PropTypes.bool,
  semibold: PropTypes.bool,
  italic: PropTypes.bool,
  light: PropTypes.bool,
  white: PropTypes.bool,
  brand: PropTypes.bool,
  small: PropTypes.bool,
  large: PropTypes.bool,
  marginBottom: PropTypes.bool,
  noMarginBottom: PropTypes.bool,
  uppercase: PropTypes.bool,
  centered: PropTypes.bool,
  smSmall: PropTypes.bool,
  useParentSize: PropTypes.bool,
  useParentFontWeight: PropTypes.bool,
}

const componentDefaultProps = {
  className: undefined,
  serif: false,
  sans: false,
  bold: false,
  semibold: false,
  italic: false,
  light: false,
  white: false,
  brand: false,
  small: false,
  large: false,
  marginBottom: false,
  noMarginBottom: false,
  uppercase: false,
  centered: false,
  smSmall: false,
  useParentSize: false,
  useParentFontWeight: false,
}

function makeTypographyComponent({
  tag: Tag,
  componentStyle,
  defaultProps = {},
}) {
  function Component({
    children,
    serif,
    sans,
    bold,
    semibold,
    italic,
    light,
    white,
    brand,
    small,
    large,
    marginBottom,
    noMarginBottom,
    uppercase,
    centered,
    smSmall,
    useParentSize,
    useParentFontWeight,
    className,
  }) {
    return (
      <Tag
        className={classNames(
          typography,
          componentStyle,
          {
            [serifStyle]: defaultProps.serif || serif,
            [sansStyle]: defaultProps.sans || sans,
            [boldStyle]: defaultProps.bold || bold,
            [semiboldStyle]: defaultProps.semibold || semibold,
            [italicStyle]: defaultProps.italic || italic,
            [lightStyle]: defaultProps.light || light,
            [whiteStyle]: defaultProps.white || white,
            [brandStyle]: defaultProps.brand || brand,
            [smallStyle]: defaultProps.small || small,
            [largeStyle]: defaultProps.large || large,
            [marginBottomStyle]: defaultProps.marginBottom || marginBottom,
            [noMarginBottomStyle]:
              defaultProps.noMarginBottom || noMarginBottom,
            [uppercaseStyle]: defaultProps.uppercase || uppercase,
            [centeredStyle]: defaultProps.centered || centered,
            [smSmallStyle]: defaultProps.smSmall || smSmall,
            [useParentSizeStyle]: defaultProps.useParentSize || useParentSize,
            [useParentFontWeightStyle]:
              defaultProps.useParentFontWeight || useParentFontWeight,
          },
          className,
        )}
      >
        {children}
      </Tag>
    )
  }

  Component.propTypes = componentPropTypes
  Component.defaultProps = componentDefaultProps

  return Component
}

export const PageHeading = makeTypographyComponent({
  tag: "h1",
  componentStyle: heading,
  defaultProps: { bold: true, serif: true, marginBottom: true },
})

export const PageSubHeading = makeTypographyComponent({
  tag: "p",
  componentStyle: heading,
  defaultProps: { serif: true, marginBottom: true },
})

export const Title = makeTypographyComponent({
  tag: "h2",
  componentStyle: title,
  defaultProps: { marginBottom: true },
})

export const SubTitle = makeTypographyComponent({
  tag: "h3",
  componentStyle: title,
  defaultProps: { marginBottom: true },
})

export const BodyText = makeTypographyComponent({
  tag: "p",
  componentStyle: body,
})

export const InlineText = makeTypographyComponent({
  tag: "span",
  componentStyle: body,
})

export const Strong = makeTypographyComponent({
  tag: "strong",
  componentStyle: body,
  defaultProps: { bold: true },
})
